import Box from '@redbubble/design-system/src/Box';
import Skeleton from '@redbubble/design-system/src/Skeleton';
import Stack from '@redbubble/design-system/src/Stack';

export const ProductReviewsSkeleton = () => {
  return (
    <Box marginY="m">
      <Box marginBottom="xs">
        <Skeleton height={26} width={80} animated roundedCorners />
      </Box>
      <Stack spacing="xxs">
        <Skeleton height={26} width={150} animated roundedCorners />
        <Skeleton height={26} width={200} animated roundedCorners />
      </Stack>
      <Box marginY="m">
        <Skeleton height={70} animated roundedCorners />
      </Box>
    </Box>
  );
};
